import React from 'react'
import { useTranslation } from 'react-i18next'
import { Breadcrumbs, Crumb } from '@carsys/ui'
import { useBreadCrumbDataContext } from 'app/crumbs/context/useSetBreadCrumbData'
import { UUIDPathRegex } from '@cbgms/base/utils/uuid'

export const TendersBreadCrumbs: React.FC<React.ComponentProps<typeof Breadcrumbs>> = ({ ...props }) => {
  const { t } = useTranslation()
  const { breadCrumbData } = useBreadCrumbDataContext()
  return (
    <Breadcrumbs {...props}>
      <Crumb
        key='tenders-appointments'
        data-testid='tenders-appointments'
        path='/tenders/appointments'
        text={t('Tender.AppointmentList')}
      />
      <Crumb
        key='tenders-id'
        data-testid='tenders-id'
        path={`/tenders/:tenderID(${UUIDPathRegex})`}
        text={breadCrumbData.tenderCode || t('Tender.Title')}
      />
    </Breadcrumbs>
  )
}

export default TendersBreadCrumbs
